import React from "react";
import { Form, Input, Row, Select, Col } from "antd";
import SortDraggableList from "../SortDraggableList";

const FooterAboutLinksSort = ({ data, setData, form }) => {
  const aboutLinkItems =
    data?.about_links?.map((item, idx) => ({
      id: idx.toString(),
      ...item,
    })) || [];

  const renderLinkContent = (field, index) => (
    <Row style={{ margin : 0, width: "100%"}} gutter={16} >
      <Col span={12}>
      <Form.Item
        label="Link Name"
        name={[field.name, "link_name"]}
        rules={[
          {
            required: true,
            message: "This field is required",
          },
        ]}
      >
        <Input />
      </Form.Item>
      </Col>

     <Col span={12}>
        <Form.Item
          label="Select Link Type"
          name={[field.name, "link_type"]}
          rules={[
          {
            required: true,
            message: "This field is required",
          },
        ]}>
        <Select
          options={[
            {
              value: "internal",
              label: "Internal",
            },
            {
              value: "external",
              label: "External",
            },
          ]}
        />
      </Form.Item>
     </Col>
     <Col span={24}> <Form.Item
        shouldUpdate={(prevValues, currentValues) =>
          prevValues.about_links?.[index]?.link_type !==
          currentValues.about_links?.[index]?.link_type
        }
        noStyle
      >
        {({ getFieldValue }) => {
          let type = getFieldValue(["about_links", index, "link_type"]);

          return (
            <>
              {type === "external" && (
                <Form.Item
                  label="Link Url"
                  name={[field.name, "redirect_path"]}
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              )}
              {type === "internal" && (
                <>
                  <Form.Item
                    label="Link Url"
                    name={[field.name, "redirect_path"]}
                    rules={[
                      {
                        required: true,
                        message: "This field is required",
                      },
                    ]}
                  >
                    <Input addonBefore={process.env.REACT_APP_CUSTOMER_SITE_URL} />
                  </Form.Item>
                </>
              )}
            </>
          );
        }}
      </Form.Item></Col>
    </Row>
  );

  return (
    <SortDraggableList
      items={aboutLinkItems}
      renderContent={renderLinkContent}
      setData={setData}
      form={form}
      formField="about_links"
      addContent={true}
      showRemoveOption={true}
      cardTitle="About Link"
    />
  );
};

export default FooterAboutLinksSort;
